import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Booking } from 'src/app/core/models/booking.model';
import { SessionNote } from 'src/app/core/models/session-note.model';
import { BookingsService } from 'src/app/core/services/bookings.service';
import { SessionNotesService } from 'src/app/core/services/session-notes.service';

@Component({
  selector: 'app-instructor-notes',
  templateUrl: './instructor-notes.component.html',
  styleUrls: ['./instructor-notes.component.scss']
})
export class InstructorNotesComponent implements OnInit {
  safeHtmlNotes: SafeHtml;
  booking: Booking;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private bookingsService: BookingsService, private parentDilogRef: MatDialogRef<InstructorNotesComponent>, private sanitizer: DomSanitizer) {
    this.booking = this.data.booking;
  }

  done() {
    this.parentDilogRef.close();
  }

  ngOnInit(): void {
    this.safeHtmlNotes = this.sanitizer.bypassSecurityTrustHtml(
      this.booking.notes
    )
  }
}


